import storeFeatureSprite from '@/shared/assets/images/locate-store/new-icons-sprite.png';
import { cn } from '@/shared/utils/cn';
import type { StoreFeatureIconId } from '../data/storeFeatureSections.data';

type StoreFeatureIconProps = {
  iconId: StoreFeatureIconId;
  className?: string;
};

const ICON_STYLES: Record<
  StoreFeatureIconId,
  { width: number; height: number; backgroundPosition: string }
> = {
  collection: { width: 101, height: 100, backgroundPosition: '0 -199px' },
  customization: { width: 101, height: 100, backgroundPosition: '-100px -199px' },
  consultant: { width: 101, height: 100, backgroundPosition: '-196px -198px' },
  certification: { width: 113, height: 100, backgroundPosition: '2px 0' },
  refund: { width: 80, height: 100, backgroundPosition: '-116px 11px' },
  exchange: { width: 101, height: 100, backgroundPosition: '-191px 0' },
};

export function StoreFeatureIcon({ iconId, className }: StoreFeatureIconProps) {
  const iconStyle = ICON_STYLES[iconId];

  return (
    <span
      aria-hidden
      className={cn('inline-block shrink-0 bg-no-repeat', className)}
      style={{
        width: iconStyle.width,
        height: iconStyle.height,
        backgroundImage: `url(${storeFeatureSprite})`,
        backgroundPosition: iconStyle.backgroundPosition,
        backgroundSize: 'auto',
      }}
    />
  );
}
